// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ze","sectionHeading":"_e"};